import css from './SubscribeBox.module.css'

export default function SubscribeBox() {
    return (
        <div className={css.subscribeBox}>
            <form
                action="https://doist.us3.list-manage.com/subscribe/post?u=622d7f00ee3556530397fd437&amp;id=b1e4a8b5d0"
                method="post"
                name="mc-embedded-subscribe-form"
                target="_blank"
                noValidate
            >
                <input
                    type="email"
                    name="EMAIL"
                    className={css.inputField}
                    placeholder="Your email"
                />

                {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
                <div className={css.hiddenBotPrune} aria-hidden="true">
                    <input
                        type="text"
                        name="b_622d7f00ee3556530397fd437_b1e4a8b5d0"
                        tabIndex={-1}
                        defaultValue=""
                    />
                </div>

                <input
                    type="submit"
                    value="Get Updates"
                    name="subscribe"
                    className={css.submitButton}
                />
            </form>

            <p>Have new guides sent to your inbox as we publish them.</p>
        </div>
    )
}
